/* global Office */

export function formatXml(xml: string, indentSize = 2): string {
  const indentUnit = " ".repeat(indentSize);
  const normalized = xml.replace(/>\s*</g, ">\n<").trim();
  let level = 0;
  return normalized
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((line) => {
      const isClosing = line.startsWith("</");
      const isSelfClosing = line.endsWith("/>") || line.startsWith("<?") || line.startsWith("<!");
      const isOpening = line.startsWith("<") && !isClosing && !isSelfClosing;
      const gtIndex = line.indexOf(">");
      const isInlineOpenClose = isOpening && gtIndex >= 0 && line.indexOf("</", gtIndex + 1) !== -1;
      if (isClosing) level = Math.max(0, level - 1);
      const out = indentUnit.repeat(level) + line;
      if (isOpening && !isInlineOpenClose) level += 1;
      return out;
    })
    .join("\n");
}

export const getXmlContentByNamespace = (namespace: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    Office.context.document.customXmlParts.getByNamespaceAsync(namespace, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded && result.value.length > 0) {
        const xmlPart = result.value[0];
        xmlPart.getXmlAsync({}, (eventArgs) => {
          if (eventArgs.status === Office.AsyncResultStatus.Succeeded) {
            resolve(eventArgs.value);
          } else {
            reject(new Error(`Failed to get XML for namespace: ${namespace}`));
          }
        });
      } else {
        resolve("");
      }
    });
  });
};
